import React, { createContext, useState } from 'react';
import { ICategoriesTree, ISaveTechnicalQuestionnaireRes } from "../Models/thirdPartyQuestionnarieModels";
import { ChildrenProps } from "../customTypes/valueTypes";

export const ThirdPartyQuestionnaireContext = createContext<null | IThirdPartyQuestionnaireContext>(null);

export interface IThirdPartyQuestionnaireContext {
    questionsToAsk: ICategoriesTree[];
    setQuestionsToAsk: React.Dispatch<React.SetStateAction<ICategoriesTree[]>>;
    userInfo: ISaveTechnicalQuestionnaireRes | null
    setUserInfo: React.Dispatch<React.SetStateAction<ISaveTechnicalQuestionnaireRes | null>>
    flagSubmitDisabled: boolean;
    setFlagSubmitDisabled: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ThirdPartyQuestionnaireProvider = (props: ChildrenProps) => {
    const [questionsToAsk, setQuestionsToAsk] = useState<ICategoriesTree[]>([]);
    const [userInfo, setUserInfo] = useState<null | ISaveTechnicalQuestionnaireRes>(null);
    const [flagSubmitDisabled, setFlagSubmitDisabled] = useState(false);

    const payload: IThirdPartyQuestionnaireContext = {
        questionsToAsk,
        setQuestionsToAsk,
        userInfo,
        setUserInfo,
        flagSubmitDisabled,
        setFlagSubmitDisabled
    }

    return (
        <ThirdPartyQuestionnaireContext.Provider value={payload}>
            {props.children}
        </ThirdPartyQuestionnaireContext.Provider>
    )
};